import { Component, Inject, OnInit, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { VerticalOptions } from '@cmps/ng-chart';

import { AuthService } from '../auth/auth.service';
import { CmpsDatePipe } from '../common/date.pipe';
import { CmpsPercentPipe } from '../common/number.pipe';
import { WidgetConfiguration } from '../widget/config.widget.model';
import { CMPS_WIDGET_CONFIG } from '../widget/widget.metadata';
import { WidgetService } from '../widget/widget.service';
import { createTeamDashboardUrl } from '../widget/widget.util';

import { CurrentPerformanceChart } from './current-performance-chart.widget.model';
import { TranslationKeyMap } from './legacy-widget.i18n';
import { LegacyWidgetService } from './legacy-widget.service';

@Component({
    selector: 'cmps-widget-current-performance-chart',
    templateUrl: './current-performance-chart.widget.component.html',
})
export class CurrentPerformanceChartWidgetComponent implements OnInit {
    i18n = TranslationKeyMap;
    hasPendingData: boolean;
    options: VerticalOptions;
    data: CurrentPerformanceChart;

    /** @private */
    _showGoToDashboardButton: boolean;

    constructor(
        private readonly _router: Router,
        private readonly _service: LegacyWidgetService,
        private readonly _authService: AuthService,
        private readonly _datePipe: CmpsDatePipe,
        private readonly _widgetService: WidgetService,
        private readonly _percentPipe: CmpsPercentPipe,
        /** @private */ @Optional()
        @Inject(CMPS_WIDGET_CONFIG)
        public _config: WidgetConfiguration,
    ) {
        this._evalAttributes();
    }

    ngOnInit(): void {
        this.options = {
            rect: { width: '100%', height: 250, top: 10 },
            yAxis: (yAxis) =>
                yAxis.tickFormat((d) =>
                    this._percentPipe.transform(d / 100, '1.1-1'),
                ),
            color: (d, i) => (d.data[d.key] > 0 ? 'green' : 'red'),
        };

        this.hasPendingData = true;
        this._service
            .currentPerformanceChart()
            // eslint-disable-next-line no-return-assign
            .subscribe(
                (data) => (this.data = data),
                // eslint-disable-next-line n/handle-callback-err, no-return-assign
                (error) => (this.hasPendingData = false),
                // eslint-disable-next-line no-return-assign
                () => (this.hasPendingData = false),
            );
    }

    goToTeamDashboard(): void {
        const url = createTeamDashboardUrl(
            this._datePipe,
            this._authService.user.id,
            this._widgetService.dateRange.value.eventDateLocal,
            2,
        );
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._router.navigate(['internal', 'webform'], {
            queryParams: { relativeUrl: url },
        });
    }

    // TODO revise
    private _evalAttributes(): void {
        if (!this._config || !this._config.attributes) {
            return;
        }
        this._config.attributes
            .filter((attr) => attr.name != null && attr.value != null)
            .map((attr) => {
                attr.name = attr.name.toLowerCase();
                attr.value = attr.value.toLowerCase();
                return attr;
            })
            .forEach((attr) => {
                if (attr.name === 'showgotodashboardbutton')
                    this._showGoToDashboardButton =
                        attr.value !== '0' && attr.value !== 'false';
            });
    }
}
